import { render } from "./projectEdit.vue?vue&type=template&id=c70fd2a8"
import script from "./projectEdit.vue?vue&type=script&lang=js"
export * from "./projectEdit.vue?vue&type=script&lang=js"

import "./projectEdit.vue?vue&type=style&index=0&id=c70fd2a8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__